








































import Vue from 'vue';
import BannerSwiper from '@/components/BannerSwiper.vue';
import { ArrowCirclerightIcon } from '@tencent/wphk-icon-vue';
import { isShowDapuHelp } from '@/business/limited-config';
import { windowHelper } from '@tencent/ppd-base-libs';

export default Vue.extend({
  name: 'Header',
  components: {
    BannerSwiper,
    ArrowCirclerightIcon,
  },
  props: {
    bannerConfigList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isShowDapuHelp: isShowDapuHelp(),
    };
  },
  methods: {
    handleFpsClick() {
      windowHelper.redirect('https://transfer.moneydata.hk/cgi-bin/fpstrans/ia_fpstrans_homepage_init.cgi?page=/entry/dapuFpsId&adtag=charity');
    },
    handleBankClick() {
      windowHelper.redirect('https://transfer.moneydata.hk/cgi-bin/fpstrans/ia_fpstrans_homepage_init.cgi?page=/entry/dapuBank&adtag=charity');
    },
  },
});
